import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <div className='header'>
     <div className='header-contents'>
        <h2>Order your favourite food here</h2>
        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus aspernatur, porro non consectetur obcaecati est enim voluptates repellendus ex. Voluptatum voluptas eos quas quia obcaecati repudiandae libero? Aperiam, suscipit facere.</p>
        <button>View Menu</button>
     </div>
    </div>
  )
}

export default Header